import {injectable} from "inversify";
import {ShopService} from "@/services/shop-service";
import {TabbedPanel} from "@/scenes.ui/tabbed-panel";
import {Tr} from "@/i18n/i18n";
import ShopStore from "@/store/shop";
import {Player} from "@/store/player/types";
import PlayerStore from "@/store/player";
import {HeroExchangeOptions, ShopCreature} from "@/store/shop/types";
import {ShopCreaturePanel} from "@/scenes.ui/shop-creature-panel";
import {CreatureUtils} from "@/utils/creature-utils";
import {HeroShopService} from "@/services/hero-shop-service";
import Container = Phaser.GameObjects.Container;
import {ValuteHeroPanel} from "@/scenes.ui/valute-hero-panel";
import ShopUtils from "@/utils/shop-utils";
import {IntegrationUtils} from "@/utils/integration-utils";
import {AmetistHeroPanel} from "@/scenes.ui/ametist-hero-panel";
import SoundUtils from "@/utils/sound-utils";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import {BuyCreatureConfirmationPanel} from "@/scenes.ui/buy-creature-confirmation-panel";
import {NewCreaturePanel} from "@/scenes.ui/new-creature-panel";

@injectable()
export class AmetistShopService extends ShopService {

    protected createTabbedPanel(): TabbedPanel {
        let self = this;
        return new TabbedPanel(this.scene!, this.canvas!, Tr('heroes.island'), ['bank', 'heroes'],
            [Tr('bank'), Tr('geroi')], [true, true], this.selectSound, (tabId: string) => {
                if (tabId === 'bank') {
                    this.populateBankTab();
                } else if (tabId === 'heroes') {
                    this.populateHeroesTab();
                }
            }, () => {}, () => self.closeCallback());
    }

    protected populateHeroesTab(): void {
        let self = this;

        let player = PlayerStore.getPlayer()!;
        this.setupHeroAgitations(player);

        ShopStore.fetchAmetistShopCreatures().then((shopCreatures: ShopCreature[]) => {
            let panels: Container[] = [];
            let self = this;

            panels.push(...HeroShopService.getTopTextsByTabId(this.scene!, this.canvas!));

            let panelY = 0;
            shopCreatures.forEach(sc => {
                let classText = CreatureUtils.getClassName(sc.creature.warriorClass);
                if (!classText) {
                    return;
                }

                let scp = new AmetistHeroPanel(this.scene!, 0, panelY, sc, self.statClickCallback,() => {
                    if (PlayerStore.getPlayer().sulfur < sc.price) {
                        SoundUtils.play(self.levelUpSound);
                        new FeedbackPanel(self.scene!, Tr('not.enough.amethysts'), self.tabbedPanel!, false).show();
                    } else {
                        let isSquadFull = CreatureUtils.findNonTemporalCreatures(PlayerStore.getPlayer().creatures).length >= ShopService.MAX_CREATURES;
                        let confirmPanel: BuyCreatureConfirmationPanel = new BuyCreatureConfirmationPanel(this.scene!, this.canvas!,
                            this.tabbedPanel!.depth + 1, sc, () => {
                                SoundUtils.play(self.awardSound);
                                ShopStore.buyCreatureAmetist(sc.id).then(() => {
                                    sc.creatures.forEach(c => {
                                        new NewCreaturePanel(self.scene!, self.canvas!, c).open();
                                    });
                                });
                            }, isSquadFull, ShopService.MAX_CREATURES);
                        confirmPanel.open();
                    }
                });

                panels.push(scp);
                panelY += ShopCreaturePanel.HEIGHT;
            });

            this.tabbedPanel.supplyChildren('heroes', panels);
        });
    }

    protected setupHeroAgitations(player: Player) {
        this.tabbedPanel.setAgitationText(Tr('amethysts.you.have') + player.sulfur);
    }
}
